// extracted by mini-css-extract-plugin
export default {"listTitle":"SharedWithMeArticlesList_listTitle__TTTdW","listContainer":"SharedWithMeArticlesList_listContainer__zwY9w"};